import React from 'react';

const FormContext = React.createContext(null);

export default FormContext;